import { render, staticRenderFns } from "./SharedShopDataBanner.vue?vue&type=template&id=557199d5&scoped=true&lang=pug&"
import script from "./SharedShopDataBanner.vue?vue&type=script&lang=js&"
export * from "./SharedShopDataBanner.vue?vue&type=script&lang=js&"
import style0 from "./SharedShopDataBanner.vue?vue&type=style&index=0&id=557199d5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557199d5",
  null
  
)

/* custom blocks */
import block0 from "./SharedShopDataBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports